import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import './board.css';

import DNF from './data-model/dnf/Main';
import Chaotic from './data-model/chaotic/Main';
import MackeyGlass from './mackey-glass/Main';
import ReservoirUnits from './reservoir-units/Main';
import SamplingRate from './sampling-rate/Main';
import SpectralRadius from './spectral-radius/Main';
import Results from './results/Main';
import Discussion from './discussion/Main';

import SideBar from './sections/SideBar';
import ReservoirConstruction from './sections/ReservoirConstruction';

import StickyBox from "react-sticky-box";

function App() {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12 col-lg-4 col-xl-3 col-xxxl-2">
          <StickyBox>
          <SideBar />
          </StickyBox>
        </div>
        <div className="col-12 col-lg-8 col-xl-9 col-xxxl-10">
          <div className="row">
            <div className="col-12 col-xl-5 col-xxxl-5">
              <h4 className="p-2 text-primary text-uppercase h-border">Reservoir Construction</h4>
              <div className="px-2">
                <ReservoirConstruction />
              </div>
              <h4 className="p-2 text-primary text-uppercase h-border">Data Model</h4>
              <div className="px-2">
                <DNF />
                <Chaotic />
              </div>
            </div>
            <div className="col-12 col-xl-7 col-xxxl-7">
              <h4 className="p-2 text-primary text-uppercase h-border">Reservoir Prediction</h4>
              <div className="row">
                <div className="col-12 col-xxxl-6">
                  <div className="pl-2">
                    <p>
                      Input scaling and spectral radius codetermine the nonlinearity of the reservoir dynamics.
                      Larger amplitudes and spectral radii imply longer-range interactions between neurons slower signal decay.
                      Balancing these two parameters is crucial to obtaining a usable prediction.
                    </p>
                    <MackeyGlass />
                    <ReservoirUnits/>
                  </div>
                </div>
                <div className="col-12 col-xxxl-6">
                  <div className="pr-2">
                    <SamplingRate />
                    <SpectralRadius />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <h4 className="p-2 text-center text-primary text-uppercase" style={{ borderBottom: '2px solid #000' }}>Results</h4>
          <div className="row">
            <div className="col-12">
              <Results />
            </div>
          </div>
          <h4 className="p-2 text-primary text-uppercase" style={{ borderBottom: '2px solid #000' }}>Discussion & Future Work</h4>
          <div className="row">
            <div className="col-12">
              <div className="px-2">
                <Discussion />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
